namespace SP {
    export interface ProductionInfo {
        item: ItemInfo;
        missingAssembly: number;
        missingDisassembly: number;
    }
}